import { apiFetch } from '../../lib/api'
import type { PlannedRecordWrite } from './recordWrites'
export { missingOverrideReasons } from './decisionRules'
export { recordWriteLine, type PlannedRecordWrite } from './recordWrites'

export interface EvidenceGapRequirement {
  id: string
  title: string
  status: 'open' | 'fulfilled' | 'waived'
  effective_status:
    'open' | 'fulfilled' | 'waived' | 'fulfilment_withdrawn' | 'superseded_requirement'
  waiver_reason: string | null
  fulfilled_document_id: string | null
  source_document_id: string
}

export interface EvidenceCheck {
  check_id: string
  label: string
  factor: string
  result: 'pass' | 'fail' | 'unknown' | 'not_applicable'
  required: boolean
  asserted: unknown
  recorded: unknown
  detail: string | null
  source_location?: { page?: number; snippet?: string } | null
}
export interface EvidencePreview {
  evidence_status_id: string
  document_id: string
  document_title: string
  status: string
  stored_status: string
  report: {
    schema_version: number
    checks: EvidenceCheck[]
    original_failure: string | null
    original_summary: string
  }
  reviewed_binding: string
  failed_check_ids: string[]
  inconclusive_check_ids: string[]
  can_accept: boolean
  required_reason_check_ids: string[]
  evidence_gap_requirements?: EvidenceGapRequirement[]
  evidence_gap_error?: string | null
  new_evidence_waiver_ids?: string[]
  pending_decision_id: string | null
  association:
    | { position_id: string; position_link_id: string; witness_kind?: never }
    | {
        position_id: string
        witness_kind: 'authorisation_entities'
        holder_link_id: string
        issuer_link_id: string
      }
    | null
  effective_decision: {
    id: string
    actor: { id: string; name: string } | null
    action: string
    reasons: Record<string, string>
    applied_at: string
    resolved_check_ids?: string[]
  } | null
  /** The record blanks an accept will fill (decision 60): empty when the
   *  record already states every figure the document does. */
  record_writes: PlannedRecordWrite[]
}
export interface DecisionState {
  id: string
  outcome: 'pending' | 'applied' | 'stale' | 'refused'
  detail: string | null
}
export function previewEvidence(
  requirementId: string,
  documentId: string
): Promise<EvidencePreview> {
  return apiFetch(
    `/api/evidence-status/${requirementId}/review?document_id=${encodeURIComponent(documentId)}`
  )
}
export function submitEvidence(
  preview: EvidencePreview,
  action: 'accept' | 'discard',
  reasons: Record<string, string>,
  idempotencyKey: string,
  taskId?: string,
  associateDocument = false
): Promise<DecisionState> {
  return apiFetch(`/api/evidence-status/${preview.evidence_status_id}/decisions`, {
    method: 'POST',
    body: JSON.stringify({
      action,
      document_id: preview.document_id,
      reviewed_binding: preview.reviewed_binding,
      idempotency_key: idempotencyKey,
      reasons: action === 'accept' ? reasons : {},
      task_id: taskId ?? null,
      associate_document: action === 'accept' && associateDocument,
    }),
  })
}
export function readEvidenceDecision(id: string): Promise<DecisionState> {
  return apiFetch(`/api/evidence-status/decisions/${id}`)
}
